import styled, { keyframes, css } from "styled-components";
import { rgba } from "polished";
import { px2rem } from "common/helpers/rem";

export const ThreadInputWrapper = styled.div`
  padding: ${px2rem(5)} 0;
`;
ThreadInputWrapper.displayName = "ThreadInputWrapper";

export const ThreadTopLabel = styled.span`
  display: inline-block;
  vertical-align: top;
  width: ${px2rem(33)};
  height: ${px2rem(18)};
  margin-left: ${px2rem(4)};
  font-size: ${px2rem(10)};
`;
ThreadTopLabel.displayName = "ThreadTopLabel";

interface IThreadFooterItemProps {
  active: boolean;
}

export const ThreadFooterItem = styled.span<IThreadFooterItemProps>`
  font-size: ${px2rem(11)};
  line-height: 1.45;
  color: ${props => (props.active ? props.theme.grey900 : props.theme.grey700)};
  & + &::before {
    content: "·";
    margin: 0 ${px2rem(4)};
    color: ${props => props.theme.grey700};
  }
`;
ThreadFooterItem.displayName = "CommentFooterItem";

export const ThreadHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
ThreadHeader.displayName = "ThreadHeader";

export const ThreadCount = styled.span`
  color: ${props => props.theme.grey800};
`;
ThreadCount.displayName = "ThreadCount";

export const CountIndicatorBox = styled.label`
  display: block;
  width: 100%;
  font-size: ${px2rem(11)};
  padding: ${px2rem(8)} 0 ${px2rem(8)} ${px2rem(44)};
  font-weight: ${props => props.theme.weightBold};
  color: ${props => props.theme.grey600};
  cursor: pointer;
  position: relative;
  line-height: ${px2rem(18)};
  &::before {
    content: "";
    display: block;
    width: ${px2rem(16)};
    height: ${px2rem(1)};
    background-color: ${props => props.theme.grey500};
    left: ${px2rem(17)};
    top: 50%;
    position: absolute;
    transform: translate3d(0, -50%, 0);
  }
`;
CountIndicatorBox.displayName = "CountIndicatorBox";

const threadHighlighting = (props: { theme: Vingle.ITheme }) => keyframes`
  0% {
   background-color: transparent;
  }
  20%, 80% {
    background-color: ${rgba(props.theme.red600, 0.1)};
  }
  100% {
    background-color: transparent;
  }
`;

export const ThreadWrapper = styled.div<{
  isPosting: boolean;
}>`
  position: relative;
  ${props =>
    props.isPosting &&
    css`
      animation: ${threadHighlighting(props)} 4s;
    `}
`;
